<div class="modal fade" id="dialogProdutoUnBusca" data-backdrop="static" data-keyboard="false" tabindex="-1"
  role="dialog">
  <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header bg-primary text-white">
        <h5 class="modal-title" id="title" style="font-size: 1rem;">Busca de Produtos e Serviços</h5>
        <button type="button" class="close" (click)="fechar()" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body p-2">
        <div class="row mb-3">
          <div class="col-2">
            <div class="checkbox checbox-switch switch-primary mt-1">
              <label>
                <input type="checkbox" [(ngModel)]="servico"
                  [ngModelOptions]="{standalone: true}" /><span></span>Serviço
              </label>
            </div>
          </div>
          <div class="col-2">
            <input [(ngModel)]="codigo" [ngModelOptions]="{standalone: true}" (keydown.enter)="buscar()" type="text"
              class="form-control" placeholder="Código">
          </div>
          <div class="col-8">
            <div class="input-group">
              <input [(ngModel)]="nome" (keydown.enter)="buscar()" type="text" class="form-control"
                placeholder="Nome ou Descrição">
              <div class="input-group-append" style="height: 36px;">
                <button class="btn btn-outline-secondary" (click)="buscar()" type="button">
                  <img src="assets/img/global/zoom.png" alt="Buscar" height="20" width="20">
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md">
            <table class="table table-sm table-eddy">
              <thead>
                <tr>
                  <th scope="col" style="width: 70px" class="text-center">Código</th>
                  <th scope="col" style="width: 72%">Nome</th>
                  <th *ngIf="unidade" scope="col" style="width: 140px" class="text-center">Unidades</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of lista">
                  <th *ngIf="unidade" scope="row" class="text-center">{{item.codigo}}</th>
                  <th *ngIf="!unidade" scope="row" class="text-center">
                    <a class="btn btn-sm btn-outline-primary mr-1 mb-1" (click)="enviarProduto(item)">
                      {{item.codigo}}
                    </a>
                  </th>

                  <td>
                    {{item.nome}}
                    <span *ngIf="item.material?.servico" class="badge badge-primary">Serviço</span>
                  </td>
                  <td *ngIf="unidade" class="text-center">
                    <a class="btn btn-sm btn-outline-primary mr-1 mb-1" *ngFor="let un of item.unidades"
                      (click)="enviarProdutoUn(un, item)">
                      {{un.unidade.nome}}
                    </a>
                    <a (click)="abrirCadastroUnidade(item)" class="btn btn-sm btn-outline-secondary mb-1">
                      <i class="fa fa-plus"></i>
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="row float-right" *ngIf="lista && lista.length > 0">
          <div class="col-12 mb-1">
            <lib-paginacao [(paginaCorrente)]="paginaCorrente" [(paginaTotal)]="paginaTotal"
              (paginaAnterior)="paginaAnterior()" (proximaPagina)="proximaPagina()"></lib-paginacao>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <div class="row" style="width: 100%;">
          <div class="col-4 pl-0">
            <button *ngIf="lista" data-toggle="modal" data-target="#dialogProdutoCadastro" type="button"
              class="btn btn-sm btn-primary">
              <i class="fa fa-plus"></i> Cadastrar novo {{servico ? 'Serviço' : 'Produto'}}
            </button>
          </div>
          <div class="col-2 offset-6 text-right">
            <button type="button" class="btn btn-sm btn-link" (click)="fechar()">Cancelar</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="dialogProdutoBuscaUnCad" data-backdrop="static" data-keyboard="false" tabindex="-1"
  role="dialog">
  <div class="modal-dialog modal-sm modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header bg-secondary text-white">
        Inclusão de Unidade
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-12">
            <p-autoComplete *ngIf="itemAtual" #unidade_cad_ [(ngModel)]="itemAtual.unidade" [forceSelection]="true"
              [autoHighlight]="true" [ngModelOptions]="{standalone: true}" [field]="unidadeAutoComplete.conversor"
              [suggestions]="unidadeAutoComplete.lista" (completeMethod)="unidadeAutoComplete.filtrar($event)"
              inputStyleClass="form-control form-control-sm" minLength="2" [style]="{ width: '100%' }">
              <ng-template let-unidade pTemplate="item">
                {{unidade.nome}}
              </ng-template>
            </p-autoComplete>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button (click)="incluirUnidade()" type="button" class="btn btn-secondary btn-sm">Confirmar</button>
        <button type="button" class="btn btn-sm btn-link" (click)="fecharUnidade()">Cancelar</button>
      </div>
    </div>
  </div>
</div>

<lib-produto-cadastro-dlg (callback)="buscarRegistroIncluido($event)" [servico]="servico" [login]="login">
</lib-produto-cadastro-dlg>